// extracted by mini-css-extract-plugin
module.exports =  {"breadcrumb":"style-module_breadcrumb__RiduJSBu7p4GneYuQhxQ","breadcrumbLink":"style-module_breadcrumbLink__O3BJCpDUfYlLGcv_lm4J"};